import React from 'react';
import { Pagination } from 'antd';
const CustomPagination = (props) => {
  const { className, ...rest } = props;
  return (
    <Pagination showSizeChanger={false} {...rest} className={className || ''} />
  );
};
export default CustomPagination;
